import {
  DELETE_INVESTMENT_HOLDING_DONATIONS,
  GET_INVESTMENT_HOLDING_DONATIONS,
  GET_INVESTMENT_HOLDING_DONATIONS_LIST,
  POST_INVESTMENT_HOLDING_DONATIONS,
  PUT_INVESTMENT_HOLDING_DONATIONS,
} from "../constants/actionTypes";

const defaultState = {
  donationsArr:[],
  donations:{}
};
let data=[]
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_INVESTMENT_HOLDING_DONATIONS_LIST:
        return {...state,donationsArr:[...action.payload]};
      case GET_INVESTMENT_HOLDING_DONATIONS:
        return {...state,donations:{...action.payload}};
      case POST_INVESTMENT_HOLDING_DONATIONS:
        return {...state,donationsArr:[...state?.donationsArr,action.payload]};
      case PUT_INVESTMENT_HOLDING_DONATIONS:
        data = [...state?.donationsArr];
        index = data?.findIndex(
          (setting) => setting?.id_customer === action.payload?.id_customer,
        );
        if (index != -1) data[index] = { ...action?.payload };
        return {...state,donationsArr: [...data]};
      case DELETE_INVESTMENT_HOLDING_DONATIONS:
        data = [...state?.donationsArr];
        const newData = data?.filter(
          (income) => income.id!=action.payload,
        );
        return {...state,donationsArr: [...newData]};
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
